import React from 'react';
import { useState } from 'react';
import {Modal, Button } from 'react-bootstrap';

interface ConfirmProps {
    onResponse: (resp:boolean) => void 
    headerText: string
    bodyText?: string
    onClose:() => void
}

const Confirm = (props: ConfirmProps) => {
    const [show, setShow] = useState(true);

    const handleClose = () => {
        setShow(false);
        props.onClose();
    }

    return (<Modal show={show} size="sm" onHide={handleClose}>  
    <Modal.Header closeButton>
        <Modal.Title>{props.headerText}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        {props.bodyText}
    </Modal.Body>
    <Modal.Footer>
        <div className="w-100">
        <Button variant="danger"  className="ms-1 float-end" onClick={()=> props.onResponse(true)}  >YES</Button>
        <Button variant="secondary" className="float-end" onClick={()=> props.onResponse(false)}>NO</Button>        
        </div>
    </Modal.Footer>
</Modal>)

}


export default Confirm; 